import styled from 'styled-components/macro';

import Chevron from 'icons/Chevron.svg';

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background-image: url(${Chevron});
    background-position: center;
    pointer-events: none;
  }
`;

export default SelectWrapper;
